<template lang="html">
  <div :class="content.type">
    <div class="actions">
      <div class="check-wrap" v-for="(c, i) in content.options" :key="i">
        <label class="checkbox-container" :for="'check'+i">{{ c.label }}
          <input type="checkbox" name="checkboxes" :id="'check'+i" :value="c.value" @click="checkClass(c,i)" ref="checkInput">
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    
    <button v-if="!chosen.length && !formValue.length" disabled class="btn btn-outline-light btn-lg remix-next">Next</button>
    <router-link v-if="formValue.length" :to="{ name: 'questions', params: {from: slug, q: getQ(target)} }" class="btn btn-outline-light btn-lg remix-next" :class="buttonAble(abled)">Next</router-link>
  </div>
</template>

<script>
export default {
  props: ["content", "slug"],
  data() {
    return {
      abled: false,
      chosen: [],
      formKey: false,
      formValue: [],
      target: false,
      totScore: 0
    };
  },
  watch: {
    content(newContent) {
      this.abled = false;
      this.chosen = [];
      this.formKey = false;
      this.formValue = [];
      this.target = false;
      this.totScore = 0;

      const checks = this.$refs.checkInput;

      checks.forEach( check => {
        check.checked = false;
        check.disabled = false;
      });

      newContent.options.forEach((option, i) => {
        option.state = false;
      });
    }
  },
  methods: {
    buttonAble(abled) {
      return abled ? "" : "disabled";
    },
    serializeChosen(arr) {
      return typeof arr !== "number" ? arr.sort().join("") : "";
    },
    checkClass(c, i) {
      this.target = c.target;
      this.formKey = this.content.prop;
      c.state = !c.state;
      let inpt = document.querySelectorAll(".check-wrap input");

      if (c.state) { // if checking box
        this.chosen.push(i);
        this.formValue.push(c.value);
        this.totScore += c.score;

        if (c.label === "None") {
          this.chosen = i;
          this.formValue = [c.value];
          this.totScore = 0;
          this.content.options.forEach((v, i) => {
            if (i + 1 != this.content.options.length) {
              v.state = false;
            }
          });
          inpt.forEach((v, i) => {
            if (i + 1 != inpt.length) {
              v.checked = false;
              v.disabled = true;
            }
          });
        }

      } else { // if unchecking box

        if (c.label === "None") {
          this.chosen = [];
          this.formValue = [];
          inpt.forEach((v, i) => {
            if (i + 1 != inpt.length) {
              v.disabled = false;
            }
          });

        } else {
          this.chosen = this.chosen.filter(a => a !== i);
          this.formValue = this.formValue.filter(a => a !== c.value);
          this.totScore -= c.score;
        }

      }

      this.setFormVal({
        prop: this.formKey,
        value: this.formValue,
        group: this.content.group,
        report: this.totalScore,
        score: this.totScore,
        id: parseInt(this.$router.currentRoute.params.q),
        serial: this.serializeChosen(this.chosen)
      });
      let trigger = false;
      this.content.options.forEach(function(v) {
        if (v.state) {
          trigger = true;
        }
      });
      this.abled = trigger ? true : false;
    },
    getQ(slug) {
      return this.$store.state.content[slug].id;
    },
    setFormVal(payload) {
      this.$store.commit("setFormData", payload);
    }
  },
  computed: {
    totalScore() {
      // sum version for checkbox
      let type = this.content.type;
      let scores = [];
      this.content.options.forEach(v => {
        let score = v.score ? v.score : 0;
        scores.push(score);
      });
      return scores.reduce((a, v) => {
        return a + v;
      });
    },
    targets() {
      let opt = this.content.options;
      let tar = [];
      opt.forEach(function(v) {
        tar.push(v.target);
      });
      return Array.from(new Set(tar));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.checkbox {
  width: 100%;

  @media only screen and (min-width: 40rem) {
    margin-top: gu(-1.5);
  }
}

.actions {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex-wrap: wrap;
  align-content: center;
  // width: 100%;
  margin-bottom: gu(1.5);

  @media only screen and (min-width: 40rem) {
    height: rem-calc(170);
    margin-bottom: gu(0.5);
  }

  @media only screen and (min-width: 64rem) {
    height: rem-calc(130);
  }
}

.check-wrap {
  padding-right: gu(1);
  padding-left: gu(1);
  min-width: rem-calc(264);
  margin-bottom: gu(2);

  @media only screen and (min-width: 40rem) {
    margin-bottom: rem-calc(12);
  }
}
</style>
